var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitTesting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.8,30.6H54c-0.5,0-1,0.4-1,1v26.7c0,0.5,0.4,1,1,1h21.8c0.5,0,1-0.4,1-1V31.6C76.8,31.1,76.3,30.6,75.8,30.6z  M67.1,53.1H56.2v-1.5h10.9V53.1z M67.1,45.5H56.2V44h10.9V45.5z M67.1,37.9H56.2v-1.5h10.9V37.9z M75,50.4l-4,4.1c0,0,0,0,0,0 c-0.2,0.2-0.5,0.2-0.8,0L68.8,53c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.5-0.2,0.7,0l1.1,1.2l3.6-3.7c0.2-0.2,0.5-0.2,0.7,0 C75.2,49.9,75.2,50.2,75,50.4z M75,42.7l-4,4.1c0,0,0,0,0,0c-0.2,0.2-0.5,0.2-0.8,0l-1.5-1.5c-0.2-0.2-0.2-0.6,0-0.8 c0.2-0.2,0.5-0.2,0.7,0l1.1,1.2l3.6-3.7c0.2-0.2,0.5-0.2,0.7,0C75.2,42.1,75.2,42.5,75,42.7z M75,35.5l-4,4.1c0,0,0,0,0,0 c-0.2,0.2-0.5,0.2-0.8,0l-1.5-1.5c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.5-0.2,0.7,0l1.1,1.2l3.6-3.7c0.2-0.2,0.5-0.2,0.7,0 C75.2,35,75.2,35.3,75,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,20c-13.8,0-25,11.2-25,25s11.2,25,25,25s25-11.2,25-25S78.8,20,65,20z M78.3,58.4c0,1.4-1.1,2.5-2.5,2.5H54 c-1.4,0-2.5-1.1-2.5-2.5V31.6c0-1.4,1.1-2.5,2.5-2.5h21.8c1.4,0,2.5,1.1,2.5,2.5L78.3,58.4L78.3,58.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitTesting);
export default __webpack_public_path__ + "static/media/Unit-Testing.dcfb8e8a27317a617f720b0280ccdedc.svg";
export { ForwardRef as ReactComponent };